export const getTotalParticipantProgram = (participants, programId) => {
    const data = participants.filter(item => item.programId === programId)
    const dataCount = data.length
    return dataCount
}